// Utilities
import { getDefaultStore } from '../../utility/environmentUtils'

const objFunc = () => {
  return {
    number: getDefaultStore(), // Default store to Georgia store
    address: undefined,
    addressStreet: undefined,
    city: undefined,
    hoursRaw: undefined,
    lat: undefined,
    long: undefined,
    name: undefined,
    phone: undefined,
    state: undefined,
    timezone: undefined,
    zip: undefined,
    brandId: undefined,
    mobileMoneyLocation: undefined,
    mobileMoneyType: undefined,
    defaultStoreSet: true,
    qrCodeScannedStore: false
  }
}

export default objFunc()

export const defaultObj = objFunc()
